<template>
    <div>
        <div class="modal c-modal fade in"  ref="modal" id="myModal" tabindex="-1"
             @click="$emit('close')"
             @keydown.esc="$emit('close')" >
            <div class="modal-dialog" @click.stop>
                <div class="modal-content">

                    <div class="modal-body">

                        <div class="c-modal__wrap row">

                            <table class="table">
                                <tbody>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in LZSs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in RVs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in UMs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in IPs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in RZPs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                    <tr class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in KORs" v-bind:class="itm.cssClass">
                                        <td>{{itm.value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>

    import getPropertyValue from '@/mixins/getPropertyValue.js';
    import getCrewStatusColor from '@/mixins/getCrewStatusColor.js';
    import { mapActions } from 'vuex';

    export default {
        name: "crewListModal",
        components: {
        },
        data: function () {
            return {
                entityData: null
            }
        },
        methods: {
            getPropertyValue,
            getCrewStatusColor,
            getEntity(entityId) {
                return this.$store.getters.getEntity(entityId);
            },
            focusModal() {
                this.$refs.modal.focus();
            },
            getCrewColor(crew){
                if(crew) {
                    const status = this.getPropertyValue(crew, 'status');
                    return getCrewStatusColor(status,'c-karta__bg-color--');
                } else {
                    return '';
                }
            },
            getCrewTypeList(type){
                const count = this.getPropertyValue(this.event, `vsk${type}`);
                const list = [];
                let id = 0;
                for(const crew of this.crews){
                    if(type === this.getPropertyValue(crew, 'type')){
                        list.push({
                            value: this.getPropertyValue(crew, 'volaciZnak'),
                            cssClass: this.getCrewColor(crew) + " c-karta__bg-color",
                            id: type + id++
                        });
                    }
                }
                for(let i = list.length; i < count; i++){
                    list.push({
                        value: type,
                        cssClass: this.getCrewColor(),
                        id: type + id++
                    });
                }
                return list;
            },
            ...mapActions(['sendCommand']),
        },
        props: {
            event: Object

        },
        computed:{
            crews() {
                const entityIds = this.getPropertyValue(this.event, 'posadky') || [];
                return entityIds.map(entityId => this.$store.getters.getEntity(entityId));
            },
            RZPs(){
                return this.getCrewTypeList('RZP');
            },
            UMs(){
                return this.getCrewTypeList('UM');
            },
            RVs(){
                return this.getCrewTypeList('RV');
            },
            LZSs(){
                return this.getCrewTypeList('LZS');
            },
            KORs(){
                return this.getCrewTypeList('KOR');
            },
            IPs(){
                return this.getCrewTypeList('IP');
            }
        },

        mounted() { // lifecycle hook kdy je vytvořeno už html
            this.focusModal(); // aby fungoval ESC na zavření
        }
    }
</script>

<style lang="less" scoped>
    .modal-dialog {
     max-width: 450px;
    }
    .c-modal__wrap {
        padding: 30px 20px 0 20px;
    }
    .c-karta__half-item {
        float: none;
        width: 100%;
        border: none;
        display: flex;
        td {
            width: 100%;
            text-align: left;
        }
    }
</style>